import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    align-items: center;
    padding: 0 40px;
    flex-direction: column;
`

export const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 0 40px;
`

export const FilterContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 0 40px;
    gap: 16px;
    margin-top: 28px;
    margin-bottom: 32px;
`
